/**
 * @author: yanhoup
 * @description: 将value转换成label 默认value -> label 也可以是其他键值对(需要在options中设置)
 */
interface Options {
  valueName: string;
  labelName: string;
}

/**
 * @description 将value转换成label 默认value -> label 也可以是其他键值对(需要在options中设置)
 * @param datasource
 * @param value
 * @param options
 * @returns string | number
 */
const vToLabel = (
  datasource: object[],
  value: string | number,
  options: Options = { valueName: 'value', labelName: 'label' },
): string | number => {
  let el = null;
  if (Array.isArray(datasource)) {
    el = datasource?.find((e) => e[options.valueName] !== '' && e[options.valueName] === value);
  }
  return el ? el[options.labelName] : value;
};

export { vToLabel };
